export default "__VITE_ASSET__JiTpU94r__"